// extracted by mini-css-extract-plugin
module.exports = {"top-results":"Tops_top-results__3t3lP","label":"Tops_label__ycVy7","control":"Tops_control__V3c9N"};